<template>
<!-- 设备管理 -->
    <div class="content">
        <div v-if="no_data3" class="no_data">
            <img src="../assets/icon@2x.png">
            <p>没有绑定设备或暂无数据</p>
        </div>
        <div v-else-if="!no_data3">
            <div v-if="no_data" class="title">我的设备
                <span class="uploadbox" @click="upload">
                    <img class="upload" src="../assets/icon-shangchuan@2x.png"><span class="uploadWords">上传</span>
                </span>
            </div>
            <div class="rquipment" v-for="item in equipmentData" :key=item.index>
                <div class="rquipmentCard">
                    <div class="rquipmentList">
                        <div>设备型号：{{ item.model }}
                            <router-link :to="{name: 'ShareQRcode', params: {instrumentId: item.instrumentId}}" class="share">共享</router-link>
                        </div>
                        <div>设备编号：{{ item.instrumentId }}
                          <button @click="delInst(item.instrumentId)" class="share">删除</button>
<!--                            <router-link :to="{name: 'ShareQRcode', params: {instrumentId: item.instrumentId}}" class="share">删除</router-link>-->

                        </div>
                        <div>使用人：{{ item.uname }}</div>
                        <div>MAC地址：{{ item.mac }}</div>
                        <div>使用状态：{{ item.isonline == 0 ? '离线' : '在线' }}</div>
                    </div>
                </div>
                <div @click="clickDown(item)" class="click_tiele">查看使用详情
                    <img  v-if="!item.checked" class="icon_down" src="../assets/icon_sanjiaoxing @2x.png">
                    <img v-if="item.checked" class="icon_down" src="../assets/icon_sanjiao @2x.png">
                </div>
                <div v-if="item.checked" class="view_details">
                    <table class="details_card" border="0">
                        <tr class="details_title">
                            <th>使用结束时间</th>
                           <th>气压</th>
                          <th><p style="line-height: 1">使用时长</p><p style="line-height: 1">(/min)</p></th>
<!--                            <th>档位</th>-->

                        </tr>
                        <tr v-for="data in item.rows" :key="data.index" class="detaila_list">
                            <td>{{data.endtime}}</td>
                           <td>{{data.pressure}}</td>
                            <td>{{data.usetime}}</td>
<!--                            <td>{{data.gear}}</td>-->

<!--                            <td>分钟&lt;!&ndash;<span :class="data.usetime >= 10 ? 'correct' : ''">{{ data.usetime >= 10 ? '正确' : '错误' }}</span>&ndash;&gt;</td>-->
                            <!-- <td><span class="correct" v-if="data.usetime >= 10">正确</span><span v-else-if="data.usetime < 10">错误</span></td> -->
                        </tr>
                    </table>
                </div>
            </div>
            <div class="shareBox">
                <div v-if="no_data2" class="title">我的分享</div>
                <div v-for="item in shareList" :key="item.index" class="rquipment shareContent">
                    <div class="rquipmentCard" >
                        <div class="rquipmentList">
                            <div>设备编号：<span>{{ item.instrumentId }}</span>
                              <button @click="delShare(item.instrumentId)" class="share">删除</button>

                            </div>
                        </div>
                    </div>
                    <div @click="clickShareDown(item)" class="click_tiele">查看使用详情
                        <img v-if="!item.checked" class="icon_down" src="../assets/icon_sanjiaoxing @2x.png">
                        <img v-if="item.checked" class="icon_down" src="../assets/icon_sanjiao @2x.png">
                    </div>
                    <div v-if="item.checked" class="view_details">
                        <table class="details_card" border="0">
                            <tr class="details_title">
                                <th>使用结束时间</th>
                                <th>使用时长<br/>(min)</th>
<!--                                <th>档位</th>-->
                                <th>气压</th>
                            </tr>
                            <tr v-for="data in item.rows" :key="data.index"  class="detaila_list">
                                <td>{{data.endtime}}</td>
                                <td>{{data.usetime}}</td>
<!--                                <td>{{data.gear}}</td>-->
                                <td>{{data.pressure}}</td>
<!--                                <td>分钟&lt;!&ndash;<span :class="data.usetime >= 10 ? 'correct' : ''">{{ data.usetime >= 10 ? '正确' : '错误' }}</span>&ndash;&gt;</td>-->
                                <!-- <td><span class="correct" v-if="data.usetime >= 10">正确</span><span v-else-if="data.usetime < 10">错误</span></td> -->
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {DropdownMenu, DropdownItem, Dialog} from 'vant';

Vue.use(DropdownMenu).use(DropdownItem);

export default {
    data() {
        return {
            no_data: false,
            no_data2: false,
            no_data3: true,
            equipmentData: [],
            shareList: [],
            instrumentId: ''
        };
    },
    created() {
        this.getEquipment()
    },
    methods: {
        // 设备 点击查看详情
        clickDown (item) {
            item.checked = !item.checked;
        },

        // 分享点击查看详情
        clickShareDown(item) {
            item.checked = !item.checked;
        },
      //删除设备
      delInst(instrumentId){
        this.axios.get('/weixin/delInstunment',{
          params: {
            instrumentid: instrumentId
          }
        }).then(res=>{
          Dialog.alert({
            title: '设备',
            message: '删除成功',
          }).then(() => {
            // on close
          });

          this.getEquipment()
        })
      },
    //删除分享设备
      delShare(instrumentId){
        this.axios.get('/weixin/delShare',{
          params: {
            instrumentid: instrumentId
          }
        }).then(res=>{
          Dialog.alert({
            title: '设备',
            message: '删除成功',
          }).then(() => {
            // on close
          });

          this.getEquipment()
        })
      },

        // 获取设备信息
        getEquipment() {
            this.axios.get('/weixin/getInstrumentsWithShare')
            .then(res=>{
                  if(res.data.listins[0]!=0){
                    this.instrumentId = res.data.listins[0].instrumentId
                    this.equipmentData = res.data.listins.map(v => {
                      let model = {}
                      // 88-C190641
                      // 0a188096
                      if(v.instrumentId.slice(0,2).split('')[1] == 'a') {
                        model = {model: 'JJM-V(五代)'}
                      }else if(v.instrumentId.slice(0,2).split('')[1] == 'c') {
                        if(v.instrumentId.slice(0,3).split('')[2] == 's'){
                          model = {model: '视奥乐(四代)'}
                        }else{
                          model = {model: 'JJM-DZ(四代)'}
                        }

                      }else if(v.instrumentId.slice(0,4).split('')[3] == 'C') {
                        model = {model: 'JJM-DZ(四代)'}
                      }else {
                        model = {model: ''}
                      }
                      return Object.assign({}, v, {checked: false}, model);
                    });
                    this.shareList = res.data.listshares.map(v => {
                      return Object.assign({}, v, {checked: false});
                    });

                    // 如果没有设备 也 没有分享 就显示 data3
                    if(this.equipmentData[0] || this.shareList[0]) {
                      this.no_data3 = false
                      if(this.equipmentData[0]) {
                        this.no_data = true
                      }
                      if(this.shareList[0]) {
                        this.no_data2 = true
                      }
                    }

                  }
                  }
        )
        },

        // 点击图片上传
        upload() {
            this.$router.push({
                name: 'UploadImg2',
                params: {
                    id: this.instrumentId
                }
            })
        }
    }
};
</script>

<style scoped>
.no_data {
    border-radius: 20px;
    padding: 300px 0;
    height: 800px;
    background: #fff;
}
.no_data img {
    display: block;
    margin: 0 auto 60px;
    width: 696px;
}
.no_data p {
    color: #999999;
    text-align: center;
}
.rquipment {
    margin-bottom: 28px;
}
.content,.rquipmentCard {
    padding: 28px;
}

.content .title {
    font-size: 54px;
    font-weight: 600;
}

.rquipmentCard .rquipmentList {
    line-height: 72px;
    letter-spacing: 4px;
}

.rquipmentCard div:first-child {
    position: relative;
}

.share {
    position: absolute;
    right: 0;
    text-align: center;
    color: #3f8ed4;
    width: 178px;
    font-size: 38px;
    height: 52px;
    line-height: 52px;
    border: 2px solid #3f8ed4;
    border-radius: 50px;
}

.view_details {
    height: 518px;
    overflow-y: auto;
    padding-top: 18px;
}

.click_tiele {
    padding: 46px 0;
    padding-top: 20px;
    text-align: center;
    color: #3f8ed4;
    letter-spacing: 4px;
}

.icon_down {
    width: 28px;
    vertical-align: 6px;
}

.details_card {
    font-size: 36px;
    width: 100%;
    text-align: center;
}

.details_title {
    width: 100%;
    height: 74px;
    line-height: 74px;
    background: #e6e6e6;
}

.detaila_list {
    padding: 0 12px;
    height: 86px;
    line-height: 86px;
    border-bottom: 1px solid #f0f0f0;
}

.detaila_list:last-of-type {
    border-bottom: none;
}

.detaila_list td span {
    font-size: 30px;
}

.shareContent, .rquipment {
    background: #fff;
    border-radius: 25px;
    margin-top: 30px;
}

.correct {
    color: #3f8ed4;
}
.uploadbox {
    float: right;
}
.uploadWords {
    font-size: 22px;
    color: #3f8ed4;
    vertical-align: 12px;
}

.upload {
    width: 48px;
    margin-right: 10px;
    vertical-align: -4px;
}
</style>



// WEBPACK FOOTER //
// src/views/Rquipment.vue